import { styled } from "../../styles";
import { Tile } from "../Tile";
import { DualAxisChart } from "./DualAxisChart";
import { DualAxisDataPoint, DualAxisSeries, MOCK_SERIES } from "./mockData";

const StyledTile = styled(Tile, {
  width: "376px",
  height: "340px",
  position: "relative",
  padding: "28px 32px 38px 32px",
  backgroundColor: "$white",
  cursor: "pointer",

  "@md": {
    width: "302px",
    height: "280px",
  },

  "@sm": {
    borderRadius: "$4",
    border: "1px solid $gray-40",
  },

  "&:hover": {
    boxShadow: "0 0 4px 1px rgba(0, 0, 0, 0.08)",
  },
});

const Title = styled("h3", {
  fontSize: "$text-lg",
  fontWeight: 400,
  marginBottom: "2px",
  lineHeight: "22px",
  color: "$black",
});

const LegendRow = styled("div", {
  display: "flex",
  gap: "12px",
  marginTop: "6px",
  fontSize: "11px",
  fontFamily: "$openSans",
  color: "#666",
});

const ExperimentalTag = styled("div", {
  position: "absolute",
  top: "12px",
  right: "12px",
  padding: "2px 8px",
  borderRadius: "4px",
  backgroundColor: "#FFF3E0",
  color: "#E65100",
  fontSize: "10px",
  fontFamily: "$openSans",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.3px",
});

type DualAxisChartCardProps = {
  title: string;
  series?: DualAxisSeries[];
  dataSets?: DualAxisDataPoint[][];
  onClick?: () => void;
};

export function DualAxisChartCard({
  title,
  series = MOCK_SERIES,
  dataSets,
  onClick,
}: DualAxisChartCardProps) {
  return (
    <StyledTile onClick={onClick}>
      <ExperimentalTag>Experimental</ExperimentalTag>
      <Title>{title}</Title>
      <LegendRow>
        {series.map((s) => (
          <div
            key={s.yKey}
            style={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            <svg width={10} height={10}>
              <circle cx={5} cy={5} r={4} fill={s.color} />
            </svg>
            <span>{s.label}</span>
          </div>
        ))}
      </LegendRow>
      <DualAxisChart variant="card" series={series} dataSets={dataSets} />
    </StyledTile>
  );
}
